export default {
    configuration: {
      default: "Configuration",
      title: "Configuration",
      list: {
        page_title: "Configuration"
      },
      show: {
        page_title: "Configuration"
      },
      edit: {
        page_title:"Modification de"
      }
    }
  }
